var React = require('react');

function Circledelete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.516,17.031a8.354,8.354,0,0,1-3.31-.674A8.332,8.332,0,0,1,.674,11.826a8.467,8.467,0,0,1,0-6.62A8.332,8.332,0,0,1,5.206.674a8.467,8.467,0,0,1,6.62,0,8.332,8.332,0,0,1,4.532,4.532,8.467,8.467,0,0,1,0,6.62,8.332,8.332,0,0,1-4.532,4.532,8.354,8.354,0,0,1-3.31.674ZM12.441,6.137a1.035,1.035,0,0,0,.333-.782,1.108,1.108,0,0,0-1.114-1.115,1.036,1.036,0,0,0-.782.333L8.5,6.936,6.137,4.574a1.035,1.035,0,0,0-.782-.333A1.108,1.108,0,0,0,4.241,5.355a1.036,1.036,0,0,0,.333.782L6.936,8.515,4.574,10.877a1.035,1.035,0,0,0-.333.782,1.109,1.109,0,0,0,1.114,1.115,1.034,1.034,0,0,0,.782-.333L8.5,10.079l2.378,2.362a1.035,1.035,0,0,0,.782.333,1.109,1.109,0,0,0,1.115-1.114,1.034,1.034,0,0,0-.333-.782L10.079,8.516Z","fill":"currentColor"}));
}

Circledelete.defaultProps = {"width":"17.031","height":"17.031","viewBox":"0 0 17.031 17.031"};

module.exports = Circledelete;

Circledelete.default = Circledelete;
